





























































































import { Component, Vue } from 'vue-property-decorator';
import secondaryNav from '@/components/navbars/secondary-nav.vue';
import { validationMixin } from 'vuelidate';
import { required, email } from 'vuelidate/lib/validators';
import { AuthApi } from '../../api';
import Toast from '@/components/display/toast.vue';

@Component({
	components: {
		secondaryNav,
		Toast,
	},
	validations: {
		form: {
			email: { required },
			password: { required },
			password_confirmation: { required },
		},
	},
	mixins: [validationMixin],
})
export default class Reset extends Vue {
	public form = {
		email: '',
		password: '',
		password_confirmation: '',
	};
	public submitStatus: 'ERROR' | 'PENDING' | 'OK' | null = null;
	public error = null;

	public async onSubmit(e: Event) {
		e.preventDefault();
		this.$v.$touch();
		if (this.$v.$invalid) {
			this.submitStatus = 'ERROR';
			return;
		}
		this.submitStatus = 'PENDING';

		let response;

		try {
			response = await new AuthApi().resetPassword({
				email: this.form.email,
				password: this.form.password,
				password_confirmation: this.form.password_confirmation,
				token: this.$route.params.token,
			});
		} catch (e) {
			console.log(e.response.data);

			this.error = e.response.data.message;
			this.submitStatus = 'ERROR';
			return;
		}

		new Toast().makeToast('Password Reset', 'Successfully Set', 'success');

		this.submitStatus = 'OK';
		/*this.$auth.login({
        data: {email: this.form.email, password: this.form.password},
        fetchUser: true,
        // rememberMe: true,
        // redirect: {name: 'organisations.list' : 'organisations.list'},
      });*/

		setTimeout(() => {
			this.$router.push({ name: 'auth.login' });
		}, 1000);
	}
}
